<template>
<div class="chat-box">
  <div class="title-box">
    <p style="font-size: 1.15em; font-weight: 700; padding-left: 20px;">
      <span class="mdi mdi-account-location" style="margin-right: 10px;"></span>{{selectroom.skname}}      
    </p>
  </div>
  <div class="scroll-box disp-scroll" v-if="chatLogs.length===0">
    <draggable style="height: 100%;" v-model="action" :options="{animation: 250, group: 'CHAT', handle: '.item-handle'}"></draggable>
  </div>
  <div class="scroll-box disp-scroll" @scroll="loadMessage" :class="{'talk-box': user.permission !== 2, 'watch-box': user.permission === 2}" v-if="chatLogs.length!==0">
    <div class="mdi mdi-loading mdi-spin mdi-48px" v-if="chatLogsLoading"></div>
    <draggable v-model="action" :options="{animation: 250, group: 'CHAT', handle: '.item-handle'}">
      <div>
        <Balloon
          v-for="(chat, index) in chatLogs" :key="index"
          :id="'scrollto-' + index"
          :speaker="chat.speaker"
          :name="chat.name"
          :icon="chat.icon"
          :message="chat.message"
          :time="displayDate(chat)"
          :readTime="new Date(selectroom.readTime)"
          :isBot="chat.isBot"
          :email="chat.email"
          :isManager="chat.isManager"
          :files="chat.files"
          :filename="chat.filename"
          :status="chat.status"
          :parameter="chat.parameter"
          :companyData="companyData"
          :parentComponent="parentComponent">
        </Balloon>
      </div>
    </draggable>
    <div style="height: 10vh; width: 10vw;"></div>
    <div class="loading is-typing"><span v-for="(m, i) in getTyping()" :key="i">{{ m }}</span></div>
  </div>
  <InputForm></InputForm>
</div>
</template>

<script>
import Balloon from '@/components/ui/Balloon'
import InputForm from '@/views/DashBoard/DirectTalk/InputForm'
import { mapState } from 'vuex'
import draggable from 'vuedraggable'
import { invalid } from 'moment'
export default {
  name: 'Chat',
  data () {
    return {
      uri: location.href,
      isTyping: '',
      action: [],
      isNoScroll: false
    }
  },
  props: {
    parentComponent: {
      type: String,
      required: false,
    }    
  },
  components: {
    Balloon,
    InputForm,
    draggable,
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('directtalk', ['chatData', 'roomlist', 'chatLogs', 'typing', 'selectroom', 'seeker', 'chatLogsLoading', 'messagePages', 'isVideo', 'scrolltalk', 'isGetMessageMax', 'companyData'])
  },
  methods: {
    loadMessage () {
      var target = document.querySelector('div.scroll-box')
      if (target.scrollTop === 0 && !this.isGetMessageMax) {
        this.isNoScroll = true
        this.$store.dispatch('directtalk/getMessage', {name: 'manager', pages: Number(this.messagePages + 1)})
      }
    },
    scrollDown () {
      console.debug('*** Start *** scrollDown')
      if (this.isNoScroll) {
        console.info('isNoScroll is true')
        this.isNoScroll = false
        var scrollLine = document.getElementById('scrollto-' + 20)
        console.log('scrollLine',scrollLine)
        if (!scrollLine) return
        scrollLine.scrollIntoView(true)
      } else if (this.chatLogs.length !== 0) {
        console.info('this.chatLogs.length !== 0')
        var target = document.querySelector('div.scroll-box')
        if (!target) return
        target.scrollTop = target.scrollHeight
      }
      console.debug('*** End *** scrollDown')
    },
    load(){
      for (var i in this.chatLogs){
        if (this.chatLogs[i].id == this.scrolltalk.id){
            var zzz =document.getElementById('scrollto-' + i)
            var r = zzz.getBoundingClientRect();
            var target = document.querySelector('div.scroll-box')
            target.scrollTo(0,target.scrollTop-(-r.top + 500))
        }
      }
    },
    getTyping () {
      var idx = -1
      var vm = this
      this.roomlist.active.find(function (item, i) {
        if (item.name === vm.selectroom.name) {
          idx = i
          return i
        }
      })
      if (idx > -1) {
        if (this.roomlist.active[idx].talk === 1) {
          return '入力中です...'
        } else if (this.roomlist.active[idx].talk === 0) {
          return ''
        }
      } else {
        return ''
      }
    },
    openVideoInterview () {
      console.debug('*** Start *** openVideoInterview')
      // ウェブ会議画面を開く
      console.log('My name is ' + this.user.username + '.')
      window.open('/videointerview/' + this.selectroom.name + '/' + this.user.username + '/' + this.selectroom.skname + '/' + this.user.isAgent + '/' + this.user.isVideo,
                  '_blank', 'width=600px, height=800px, left=0, top=0, directories=no, status=no, menubar=no, scrollbars=yes, location=no, toolbar=no')      
      console.debug('*** End *** openVideoInterview')
    },
    displayDate(chat) {
      if (!isNaN(chat.createdAt)) {
        return new Date(chat.createdAt)
      } else {
        return new Date(chat.createdAtOther)
      }
    }
  },
  watch: {
    chatLogs: function () {
      if (this.chatLogs.length !== 0) {
        this.$nextTick()
        setTimeout(() => {this.scrollDown()}, 0)
        this.$store.dispatch('directtalk/setIsRead', 'mgtool')
      }
    },
    scrolltalk:function () {
      setTimeout(() => {
        this.load()
      }, 1500) 
    },
    action: function () {
      // set User Info
      this.chatData.email = this.user.email
      this.chatData.url = this.uri
      this.chatData.icon = this.user.profileIcon
      this.chatData.name = this.user.username
      this.chatData.isManager = '1'
      // this.chatData.message = this.action.slice(-1)[0].text
      this.chatData.message = this.action[0].text
      // set Time
      var today = new Date()
      this.chatData.createdAt = today.toISOString()
      this.$store.dispatch('directtalk/pushAction', this.chatData)
      this.action.pop()
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.typing {
  position: fixed !important;
  left: 43vw;
  bottom: 10vh;
}
.chat-box {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.title-box {
  min-height: 48px;
  max-height: 48px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: #FEFEFE;
  border-bottom: solid thin #ccc;
}
.talk-box {
  height: calc(100% - 110px);
  width: 100%;
}
.watch-box {
  height: 100%;
  width: 100%;
}
.scroll-box {
  height: calc(100% - 110px);
  width: 100%;
}
/* アニメーション */
.v-enter-active{
  transition-duration: 0.1s;
}
.v-leave-active {
  transition-duration: 0.1s;
}
.v-enter,
.v-leave-to{
  opacity: 0;
}
.is-typing {
  position: fixed;
  left: 38vw;
  bottom: 80px;
  height: 20px;
  background-color: transparent;
  font-size: 16px;
}
/* Animation Typing */
.loading span {
  display: inline-block;
  margin: 0 -.05em;
  margin-left: 10px;
  animation: loading .7s infinite;
}
.loading span:nth-child(2) {
  animation-delay: .1s;
}
.loading span:nth-child(3) {
  animation-delay: .2s;
}
.loading span:nth-child(4) {
  animation-delay: .3s;
}
.loading span:nth-child(5) {
  animation-delay: .4s;
}
.loading span:nth-child(6) {
  animation-delay: .5s;
}
.loading span:nth-child(7) {
  animation-delay: .6s;
}
@keyframes loading {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/DirectTalk/Chat.vue